import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/t5Config',
    name: 't5Config',
    meta: {
      title: '通关配置',
      layout: 'share'
    },
    children: [
      // {
      // 	path: 'levelSort',
      // 	name: 't5LevelSort',
      // 	component: () => import('@/views/wiki/t5config/Ranking/levelSort.vue'),
      // 	meta: {
      // 		title: '关卡排行',
      // 	},
      // },
      // {
      // 	path: 'sort',
      // 	name: 't5Sort',
      // 	component: () => import('@/views/wiki/t5config/Ranking/sort.vue'),
      // 	meta: {
      // 		title: '通关排行榜',
      // 	},
      // },
      {
        path: 'configList/:entryId?',
        name: 't5configList',
        component: () => import('@/views/wiki/t5config/configList/index.vue'),
        meta: {
          title: '玩家配置'
        }
      },
      {
        path: 'passLevelDetail/:entryId?',
        name: 't5PassLevelDetail',
        component: () => import('@/views/wiki/t5config/passLevel/detail.vue'),
        meta: {
          title: '通关详情',
          userSource: 't5PassLevelDetail'
        }
      },
      {
        path: 'homePage/publishFootprint',
        name: 't5PublishFootprint',
        component: () => import('@/views/wiki/t5config/homePage/publishFootprint.vue'),
        meta: {
          title: '发布足迹'
        }
      },
      {
        path: 'homePage/:id?',
        name: 't5HomePage',
        component: () => import('@/views/wiki/t5config/homePage/index.vue'),
        meta: {
          title: '个人信息',
          userSource: 'T5_roleInfoShare'
        }
      }
    ]
  }
];

export default routes;
